import { atom } from 'jotai'
import { FilterType } from '../../../types/beFiltersApi'
import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'
import {
  type GoToRecipientModalState,
  type SubscriberCountState,
} from '../types'
import { withImmer } from 'jotai-immer'
import { getEmptyBlock } from '../utils/conditionUtils'
import { type UiFilterDetail } from '../filterConditionTypes'

export const getDefaultFilter = (): UiFilterDetail => {
  return {
    IdList: storeGet(STORE_KEY_ID_LIST) as number,
    Name: '',
    Description: '',
    Notes: '',
    Hidden: false,
    Category: 0,
    UpdateDate: '',
    Type: FilterType.MultiType,
    Blocks: [getEmptyBlock()],
    Id: 0,
    Locked: false,
    IsUsedInOtherLists: false,
  }
}

export const filterFormAtom = atom<UiFilterDetail>(getDefaultFilter())
export const filterFormImmerAtom = withImmer(filterFormAtom)

export const originalFilterAtom = atom<UiFilterDetail>(getDefaultFilter())

export const defaultSubscriberState: SubscriberCountState = {
  count: {},
  loading: false,
}
export const subscriberCountAtom = atom<SubscriberCountState>(
  defaultSubscriberState,
)

export const defaultGoToRecipientModalState: GoToRecipientModalState = {
  show: false,
  type: undefined,
}
export const goToRecipientModalAtom = atom<GoToRecipientModalState>(
  defaultGoToRecipientModalState,
)
